import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const SpinnerIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox="-8 -8 50 50"
        {...props}
      >
        <circle
          cx="18"
          cy="18"
          fill="transparent"
          stroke="currentColor"
          strokeWidth="3"
          r="15"
          strokeDasharray="70.68583470577033 25.561944901923447"
          transform="rotate(330 18 18)"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 18 18;360 18 18"
            keyTimes="0;1"
            dur="1s"
            begin="0s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    );
  }
);
export default SpinnerIcon;
